import React from "react";
import { DEFAULT_APP_DOWNLOAD_URL, APP_NAME } from "../../config/appDownload";
import "./DownloadAppBanner.css";

/**
 * Zomato-style banner: dark card with headline + CTA button + phone mock.
 * Uses <a href> so the link works reliably (no popup blocking).
 */
export default function DownloadAppBanner({ onClick, className = "" }) {
  const handleClick = (e) => {
    if (typeof onClick === "function") {
      e.preventDefault();
      onClick();
    }
    // else: let the default <a> navigation happen
  };

  return (
    <a
      href={DEFAULT_APP_DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`download-app-banner ${className}`}
      onClick={handleClick}
      aria-label={`${APP_NAME}: Online ordering is only supported on the mobile app. Download the app.`}
    >
      <div className="download-app-banner-inner">
        <div className="download-app-banner-text">
          <p className="download-app-banner-headline">
            Online ordering is only supported on the mobile app
          </p>
          <span className="download-app-banner-btn">Download the App</span>
        </div>
        <div className="download-app-banner-phone">
          <div className="download-app-phone-mock">
            <span className="download-app-phone-logo">{APP_NAME}</span>
          </div>
        </div>
      </div>
    </a>
  );
}
